import { useSelector } from "react-redux";
import {
  DrawPolygonSidebar,
  DropPinSidebar,
  PointPickerSidebar,
  ShapePickerSidebar,
  GetGpsDataSidebar,
} from "../index";
import questionTypes from "../../questionTypes";
import { panelsName } from "../../panelsTitle";

import { RootState } from "store";
import RefreshDynamicFormGeographyBtn from "../../components/RefreshDynamicFormGeographyBtn";

const CustomPropertyGridSidebar = () => {
  const { selectedQuestionElement } = useSelector(
    (state: RootState) => state.surveyJS
  );

  function _renderSidebar(element: any) {
    if (element) {
      const questionType = element?.isPanel
        ? element?.name
        : element?.getType();

      switch (questionType) {
        case questionTypes.shapePicker:
          return <ShapePickerSidebar />;

        case questionTypes.pointPicker:
          return <PointPickerSidebar />;

        case questionTypes.drawPolygon:
          return <DrawPolygonSidebar />;

        case questionTypes.dropPin:
          return <DropPinSidebar />;
        case questionTypes.getGpsData:
          return <GetGpsDataSidebar />;

        case panelsName.HARVEST:
          return (
            <>
              <ShapePickerSidebar
                heading="Retrieval Location (Region)"
                variant="retrieval"
              />
              <PointPickerSidebar
                heading="Retrieval Location (Point)"
                variant="retrieval"
              />
              <ShapePickerSidebar
                heading="Strcuk & Lost Location (Region)"
                variant="struck"
              />
              <PointPickerSidebar
                heading="Struck & Lost Location (Point)"
                variant="struck"
              />
            </>
          );

        case panelsName.GEOGRAPHICAL_INFORMATION:
          return (
            <>
              <ShapePickerSidebar heading="Region" variant="region" />
              <ShapePickerSidebar heading="View" variant="view" />
              <PointPickerSidebar
                heading="Vantage Point"
                blockMultiSelect={true}
              />
            </>
          );
      }
    }
  }

  const questionType = selectedQuestionElement?.isPanel
    ? selectedQuestionElement?.name
    : selectedQuestionElement?.getType() ?? "";
  const doShowRefreshButton =
    [
      questionTypes.pointPicker,
      questionTypes.dropPin,
      questionTypes.drawPolygon,
      questionTypes.shapePicker,
      panelsName.HARVEST,
      panelsName.GEOGRAPHICAL_INFORMATION,
    ].includes(questionType) ?? false;
  return (
    <section
      id="customPropertyGridSidebar"
      className="w-full bg-[#F3F5F7]"
      style={{ display: "none" }}
    >
      {doShowRefreshButton && <RefreshDynamicFormGeographyBtn />}

      {_renderSidebar(selectedQuestionElement)}
    </section>
  );
};

export { CustomPropertyGridSidebar };
